@if (isVisible()) {
  <div class="cookie-banner">
    <p>
      A weboldal cookie-kat (sütiket) használ a felhasználói élmény növelése és statisztikai célokból. A weboldal
      által használt cookie-k személyes adatgyűjtéséhez hozzájárulok.
    </p>
    <div class="cookie-banner__actions">
      <button type="button" (click)="acceptCookies()">Elfogadom</button>
      <button type="button" (click)="rejectCookies()">Nem fogadom el</button>
      <a href="#" (click)="onNavigateLink('/adatkezelesi-tajekoztato', $event)">További információk</a>
    </div>
  </div>
}
